import { useQuery } from "@tanstack/react-query";
import { contentQueries } from "@/api/content-review";
import { clsx } from "clsx";
import { apiUrl } from "@/components/automate/InteractionLog";
import { LoaderCircle } from "lucide-react";

export function TweetImage({
  id,
  className,
}: {
  id: string;
  className?: string;
}) {
  const query = useQuery(contentQueries.content(id));

  return (
    <div
      className={clsx(
        "flex justify-center items-center h-32 aspect-[4/3] rounded border",
        className,
      )}
    >
      {query.isSuccess ? (
        <img
          className="w-auto h-full object-cover"
          src={`${apiUrl}/get-file?url=${encodeURIComponent(query.data.thumbnail_url)}`}
          alt={query.data.image_caption}
        />
      ) : query.isLoading ? (
        <LoaderCircle className="animate-spin" />
      ) : (
        <p className="text-muted-foreground text-sm">Error loading image</p>
      )}
    </div>
  );
}
